import type { FunctionComponent } from 'react';

import styled from 'styled-components';
import { Inline, spacingHelper } from '@property.com.au/ui-kit';
import { PropertyFeature } from '../../../app-kit/components/PropertyFeatures/subcomponents/PropertyFeature';
import type { UpdatePropertyDetailsHeaderProps } from './subcomponents/UpdatePropertyDetailsHeader/UpdatePropertyDetailsHeader';
import { UpdatePropertyDetailsHeader } from './subcomponents/UpdatePropertyDetailsHeader/UpdatePropertyDetailsHeader';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { mapHeaderUpdatePropertyDetailsCta } from './helpers/mapHeaderUpdatePropertyDetailsCta';

const PropertyFeaturesContainer = styled(Inline)`
  flex-wrap: wrap;
  row-gap: ${spacingHelper('twoExtraSmall')};
`;

interface HeaderPropertyFeaturesProps {
  items: PropertyFeature[];
  updatePropertyDetailsCta?: UpdatePropertyDetailsHeaderProps;
}

export const HeaderPropertyFeatures: FunctionComponent<HeaderPropertyFeaturesProps> = ({
  items,
  updatePropertyDetailsCta,
}) => {
  return (
    <PropertyFeaturesContainer grow={false} gap="small">
      {items.map(({ iconName, title, valueWithUnit, hoverTitle }) => (
        <PropertyFeature
          key={title}
          iconName={iconName}
          title={title}
          valueWithUnit={valueWithUnit}
          hoverTitle={hoverTitle}
        />
      ))}
      {updatePropertyDetailsCta && (
        <UpdatePropertyDetailsHeader cta={updatePropertyDetailsCta.cta} />
      )}
    </PropertyFeaturesContainer>
  );
};

export const HeaderPropertyFeaturesWithData: FunctionComponent = () => {
  const cachedQuery = usePropertyPageQuery();
  const header = cachedQuery?.data.propertyPageBySlugV3.header;
  if (!header?.propertyFeatures?.items) return null;

  const { items, updatePropertyDetailsCta } = header.propertyFeatures;

  return (
    <HeaderPropertyFeatures
      items={items.map((feature) => ({ ...feature, iconName: feature.iconNameV2 }))}
      updatePropertyDetailsCta={mapHeaderUpdatePropertyDetailsCta(updatePropertyDetailsCta)}
    />
  );
};
